import { combineReducers } from "redux";
import Language from "./Language";
import Verifications from "./Verifications";
import BusinessProfile from "./BusinessProfile";
import Filters from "./Filters";
import ProfileUnits from "./ProfileUnits";
import Notifications from "./Notifications";

const appReducer = combineReducers({
  Language,
  Verifications,
  BusinessProfile,
  Filters,
  ProfileUnits,
  Notifications,
});

const rootReducer = (state, action) => {
  if (action.type === "ON_USER_LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
